import useReveal from "../hooks/useReveal";
import { AnnouncementBar } from "../components/sections/AnnouncementBar";
import { Nav } from "../components/sections/Nav";
import { Hero } from "../components/sections/Hero";
import { Programme } from "../components/sections/Programme";
import { WhoFor } from "../components/sections/WhoFor";
import { Story } from "../components/sections/Story";
import { Application } from "../components/sections/Application";
import { Resources } from "../components/sections/Resources";
import { Scholarship } from "../components/sections/Scholarship";
import { Testimonials } from "../components/sections/Testimonials";
import { FinalCTA } from "../components/sections/FinalCTA";
import { Footer } from "../components/sections/Footer";

export default function Landing() {
  const ref = useReveal();
  return (
    <div ref={ref} data-testid="landing-page" className="bg-[#050505] text-white">
      <AnnouncementBar />
      <Nav />
      <main>
        <Hero />
        {/* The offer leads — keep it priority */}
        <Programme />
        <WhoFor />
        <Story />
        <Application />
        <Resources />
        <Scholarship />
        {/* Testimonials moved near the bottom (social proof close) */}
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
